export default {
  widgets: {
    generalBanner: {
      title: 'Bewertungen',
      stars: '{averageRating} Sterne',
      reviews: '{totalReviews} Bewertungen',
    },
    supplierBanner: {
      stars: '{averageRating} Sterne',
    },
    badge: {
      smallText: 'Bewertet mit',
      largeText: '{averageRating} Sternen',
    },
  },
}
